export const identity = function<T>(val: T): T {
  return val;
};